import { Row, Select } from "antd";
import { useState, useEffect, DownOutlined } from "react";

const { Option } = Select;

export const SelectCampeonatosResultado = ({
  idCampo,
  nombreCampo,
  arrayOpciones,
  textoOpciones,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(elValue || null);
  let esRequired = required ? "*" : "";
  // console.log("Valor del selector",elValue)
  useEffect(() => {
    setSelectedValue(elValue || null);
  }, [elValue]);

  const handleSelectChange = (selectedValue) => {
    setSelectedValue(selectedValue);
    onChange({ target: { value: String(selectedValue), id: idCampo } });
  };

  return (
    <Row justify={"start"}>
      <label htmlFor={idCampo}>
        <p className="nombre-campo">{nombreCampo} {esRequired}</p>
      </label>
      <Select
      className="select-custom"
      showSearch
      autoComplete="none"
      key={idCampo + "*" + selectedValue}
      id={idCampo}
      onChange={handleSelectChange}
      placeholder={elPlaceholder}
      style={{ width: "100%" }}
      required={required}
      value={selectedValue !== null ? String(selectedValue) : undefined}
      filterOption={(input, option) =>
        (option.children || "").toLowerCase().includes(input.toLowerCase())
      }
      status={tipoError}

    >
        {/* <Option key={"vacio"} value="">
          Todos los campeonatos
        </Option> */}
      {arrayOpciones.map((option) => (
        <Option key={option.id} value={String(option.id)}>
          {option[textoOpciones]}
        </Option>
      ))}
    </Select>
      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};
